import Vue from 'vue';

const windowSizeState = Vue.observable({
  fontSize: 16,
  spacing: 0.25,
  spacingSize: 16 * 0.25,
  size: 'md',
  isMobile: false,
  isTablet: false,
  isDesktop: false,
  width: null,
  height: null,
});

function getWindowSize() {
  const width = window.innerWidth / windowSizeState.fontSize;
  // if (width < 48) return 'xs'; // 768px / 16px (default rem)
  if (width < 40) return 'sm'; // 640px / 16px (default rem)
  if (width < 48) return 'md'; // 768px / 16px (default rem)
  return 'lg';
}

function updateWindowSize() {
  windowSizeState.fontSize = parseFloat(
    getComputedStyle(document.documentElement).fontSize
  );
  windowSizeState.spacingSize =
    windowSizeState.fontSize * windowSizeState.spacing;
  const size = getWindowSize();
  windowSizeState.size = size;
  windowSizeState.height = window.innerHeight;
  windowSizeState.width = window.innerWidth;
  windowSizeState.isMobile = size === 'sm';
  windowSizeState.isTablet = size === 'md';
  windowSizeState.isDesktop = size === 'lg';
}

// Устанавливаем начальные значения
updateWindowSize();

window.addEventListener('resize', updateWindowSize);

Vue.prototype.$windowSize = windowSizeState;
